export const CBO_PUSH_MESSAGE_TYPE = "CBO_PUSH" as const;

export type CboPushLine = {
  part: string;
  qty: number;
  orderNo: string;
  customerName: string;
};

type CboItemLike = {
  partNumber?: string;
  remainingDecisionQuantity?: number;
};

type ActionRowLike = {
  partNumber: string;
  actionQuantity: number;
};

export function buildCboPushLinesFromCboItems(
  orderNo: string,
  cboItems: CboItemLike[] | null | undefined,
  customerName = "",
): CboPushLine[] {
  if (!orderNo || !Array.isArray(cboItems)) return [];
  const lines: CboPushLine[] = [];
  for (const item of cboItems) {
    const part = String(item?.partNumber ?? "").trim();
    if (!part) continue;
    const qty = Number(item?.remainingDecisionQuantity ?? 0);
    if (qty <= 0) continue;
    lines.push({ part, qty, orderNo, customerName });
  }
  return lines;
}

export function buildCboPushLinesFromActionQuantities(
  orderNo: string,
  rows: ActionRowLike[] | null | undefined,
  customerName = "",
): CboPushLine[] {
  if (!orderNo || !Array.isArray(rows)) return [];
  return rows
    .filter(
      (r) =>
        Number(r?.actionQuantity) > 0 &&
        String(r?.partNumber ?? "").trim().length > 0,
    )
    .map((r) => ({
      part: String(r.partNumber).trim(),
      qty: Number(r.actionQuantity),
      orderNo,
      customerName,
    }));
}

export function postCboPushMessage(lines: CboPushLine[]): void {
  if (typeof window === "undefined" || lines.length === 0) return;
  window.postMessage({ type: CBO_PUSH_MESSAGE_TYPE, payload: lines }, "*");
}

export function pushCboItemsToAstuteBuddy(
  orderNo: string,
  cboItems: CboItemLike[] | null | undefined,
  customerName = "",
): void {
  postCboPushMessage(
    buildCboPushLinesFromCboItems(orderNo, cboItems, customerName),
  );
}
